import { h } from "preact"
import { Image } from "./Image";

export const SuggestionProduct = ({product}) => {
  const {title, images_info, price_max, price_min, handle} = product
  const url = `/products/${ handle }`;
  const priceVary = price_max !== price_min;
  if (images_info[0] !== undefined) {
  return (
    <div class="col-3">
      <div class="search-drop__item">
        
          <a href={ url } class="search-drop__item-img image-container">
            <Image src={ images_info[0].src } sizes={ ['248x'] }/>
          </a>
        
        <div class="search-drop__item-box text-brand-black">
          <div class="h5 search-drop__item-title">
            <a href={ url }>{ title }</a>
          </div>
          <div class="search-drop__item-price">{ priceVary
            ? `starting at ${ formatMoney(price_min * 100, theme.moneyFormat) }`
            : formatMoney(price_min * 100, theme.moneyFormat) }</div>
        </div>
      </div>
    </div>
  )
  }
}
